import $ from 'jquery'
import { tsInitVue, tsInitVueGrid } from './js-utils'
import CandidateEventsGrid from "../js/vue-components/candidate-events-grid.vue"
import CandidateModal from "../js/vue-components/candidate-modal.vue"
import EventTrainerGrid from '../js/vue-components/event-trainer-grid.vue'
import { initializeAutocompleteField } from './site-utils'
import TrainerGrid from './vue-components/trainer-grid.vue'

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('body.instructors.instructors-list')) {
    const gridEl = document.querySelector('[data-is="TrainerGrid"]')
    if (gridEl instanceof HTMLElement) {
      window.trainersGrid = tsInitVueGrid(TrainerGrid, gridEl)
    }
  }

  const trainerGridEl = document.querySelector('div[data-is="EventTrainerGrid"]')
  if (trainerGridEl instanceof HTMLElement) {
      window.eventTrainerGrid = tsInitVueGrid(EventTrainerGrid, trainerGridEl)
  }

  if (document.querySelector('body.instructors.trainer-profile-show')) {
    const trainerEventsGridEl = document.querySelector('div[data-is="CandidateEventsGrid"]')
    if (trainerEventsGridEl instanceof HTMLElement) {
      window.trainerEvents = tsInitVueGrid(CandidateEventsGrid, trainerEventsGridEl)

      const editProfileBtn = document.querySelector('button[data-action="edit-profile"]')
      if (editProfileBtn instanceof HTMLElement) {
        const trainerModalEl = document.querySelector('div[data-is="CandidateModal"]')
        if (trainerModalEl instanceof HTMLElement) {
          const cModal = tsInitVue(CandidateModal, trainerModalEl, {
            modalTitle: 'Edit profile',
            onSuccess: function() {
              window.location.href = window.location.href
            }
          })

          editProfileBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const url = editProfileBtn.dataset.url
            if (url) {
              cModal.showModal(url, null)
            }
          })
        }
      }
    }
  }
})

$(function () {
  if ($('body.instructors.instructors-list').length) {
    const searchFieldEl = document.querySelector('select[ref="instructor-search"]')
    if (searchFieldEl instanceof HTMLSelectElement) {
      const searchField = initializeAutocompleteField(searchFieldEl)
      if (searchField) {
        $(searchField).on('select2:select', function (e) {
          if (e.params.data.id) {
            history.pushState({ q: e.params.data }, 'Instructor search', `?q=${e.params.data.id}`)
            window.trainersGrid?.fetchContent(e.params.data)
          }
        })

        $(searchField).on('select2:unselect', function () {
          history.pushState({ q: null }, 'instructor search', `?`)
          window.trainersGrid?.fetchContent()
        })
      }

      window.addEventListener('popstate', function (event) {
        const state = event.state
        let instructorsLoaded = false
        if (typeof state === 'object' && state !== null) {
          if (typeof state.q === 'object' && state.q !== null && state.q.id && state.q.text) {
            // has saved selection
            instructorsLoaded = true
            const newOption = new Option(state.q.text, state.q.id, true, true)
            $(searchFieldEl).append(newOption).trigger('change')
            window.trainersGrid?.fetchContent(state.q)
          } else if (state.q == null) {
            // selection has been cleared
            instructorsLoaded = true
            $(searchFieldEl).val('').trigger('change')
            window.trainersGrid?.fetchContent()
          }
        }
        if (!instructorsLoaded) {
          // no push state found, perform initial query
          $(searchFieldEl).val('').trigger('change')
          window.trainersGrid?.fetchContent()
        }
      })
    }
  }
})
